<template>
  <div>
    <div
      v-if="visible"
      class="charge-generated-overlay"
      >
      <div
        role="dialog"
        aria-labelledby="charge-generated-modal-title"
        aria-describedby="charge-generated-modal-description"
        class="charge-generated-dialog"
        @click.stop>
        <button
          type="button"
          class="charge-generated-close"
          aria-label="Fechar"
          @click="handleClose">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>

        <div class="charge-generated-header">
          <div class="charge-generated-icon-wrap">
            <svg class="charge-generated-success-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="m8.5 11.5 2.5 2.5 5.5-5.5"></path>
            </svg>
          </div>
          <div class="charge-generated-header-text">
            <h2 id="charge-generated-modal-title" class="charge-generated-title">
              Cobrança Gerada!
            </h2>
            <p id="charge-generated-modal-description" class="charge-generated-subtitle">
              {{ subtitle }}
            </p>
          </div>
        </div>

        <div class="charge-generated-card">
          <div class="charge-generated-card-col">
            <span class="charge-generated-card-label">Total</span>
            <span class="charge-generated-card-value charge-generated-card-value-total">{{ totalFormatted }}</span>
          </div>
          <div class="charge-generated-card-divider"></div>
          <div class="charge-generated-card-col">
            <span class="charge-generated-card-label">{{ countLabel }}</span>
            <span class="charge-generated-card-value">{{ userCount }}</span>
          </div>
          <div class="charge-generated-card-divider"></div>
          <div class="charge-generated-card-col">
            <span class="charge-generated-card-label">Vencimento</span>
            <span class="charge-generated-card-value charge-generated-card-value-due">{{ dueDateFormatted }}</span>
          </div>
        </div>

        <div class="charge-generated-actions">
          <a
            v-if="effectivePaymentLink"
            :href="effectivePaymentLink"
            target="_blank"
            rel="noopener noreferrer"
            class="charge-generated-btn-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4"></path>
              <path d="M4 6v12c0 1.1.9 2 2 2h14v-4"></path>
              <path d="M18 12a2 2 0 0 0-2 2c0 1.1.9 2 2 2h4v-4h-4z"></path>
            </svg>
            Realizar pagamento
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" x2="21" y1="14" y2="3"></line>
            </svg>
          </a>
          <button
            type="button"
            class="charge-generated-btn-secondary"
            @click="handleNavigate">
            {{ navigateLabel }}
          </button>
          <a
            :href="commercialWhatsAppUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="charge-generated-link-commercial">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
            Dúvida? Fale com nosso comercial
          </a>
        </div>

        <div v-if="showPlanModelDisclaimer" class="charge-generated-disclaimer">
          <svg class="charge-generated-disclaimer-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 16v-4"></path>
            <path d="M12 8h.01"></path>
          </svg>
          <p class="charge-generated-disclaimer-text">
            Após a confirmação do pagamento, é necessário <strong>sair e entrar novamente no seu Portal API4COM</strong> para que a mudança para o modelo de planos seja aplicada.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WHATSAPP_SALES_WEBHOOK_URL } from '@/utils/whatsapp'

export default {
  name: 'ChargeGeneratedModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    totalFormatted: {
      type: String,
      default: ''
    },
    userCount: {
      type: Number,
      default: 0
    },
    dueDateFormatted: {
      type: String,
      default: ''
    },
    paymentLink: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: 'Realize o pagamento para ativar os planos.'
    },
    countLabel: {
      type: String,
      default: 'Usuários'
    },
    navigateLabel: {
      type: String,
      default: 'Ir para usuários da organização'
    },
    showPlanModelDisclaimer: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      commercialWhatsAppUrl: WHATSAPP_SALES_WEBHOOK_URL
    }
  },
  computed: {
    effectivePaymentLink () {
      if (typeof this.paymentLink !== 'string') return ''
      return this.paymentLink.trim()
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    handleNavigate () {
      this.$emit('navigate')
    }
  }
}
</script>

<style scoped>
.charge-generated-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.charge-generated-dialog {
  position: relative;
  width: 90%;
  max-width: 28rem;
  background: #ffffff;
  border-radius: 0.75rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  padding: 1.5rem 1.5rem 1.25rem;
}

.charge-generated-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 0.25rem;
  color: #4b5563;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.charge-generated-close:hover {
  color: #1f2937;
}

.charge-generated-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.25rem;
  padding-right: 2rem;
}

.charge-generated-icon-wrap {
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: #dcfce7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.charge-generated-success-icon {
  stroke: #16a34a;
}

.charge-generated-header-text {
  flex: 1;
}

.charge-generated-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem 0;
}

.charge-generated-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}

.charge-generated-card {
  display: flex;
  align-items: stretch;
  background: #eefff1;
  border: 1px solid #bbf7d0;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1.25rem;
}

.charge-generated-card-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 0;
}

.charge-generated-card-label {
  font-size: 0.8125rem;
  color: #6b7280;
  margin-bottom: 0.25rem;
}

.charge-generated-card-value {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1f2937;
}

.charge-generated-card-value-total {
  color: #16a34a;
  font-size: 1.25rem;
}

.charge-generated-card-value-due {
  font-size: 0.9375rem;
  line-height: 1.3;
}

.charge-generated-card-divider {
  width: 1px;
  background: #bbf7d0;
  flex-shrink: 0;
}

.charge-generated-disclaimer {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.625rem 0.875rem;
  margin-top: 1rem;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 0.5rem;
}

.charge-generated-disclaimer-icon {
  flex-shrink: 0;
  margin-top: 0.0625rem;
  stroke: #2563eb;
}

.charge-generated-disclaimer-text {
  font-size: 0.8125rem;
  color: #1d4ed8;
  line-height: 1.4;
  text-align: left;
  margin: 0;
}

.charge-generated-disclaimer-text strong {
  font-weight: 725;
}

.charge-generated-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
}

.charge-generated-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #ffffff;
  background: #16a34a;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.2s;
}

.charge-generated-btn-primary:hover {
  background: #15803d;
}

.charge-generated-link-commercial {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  font-size: 0.7925rem;
  color: #16a34a;
  background: transparent;
  text-decoration: none;
  padding: 0.25rem 0;
}

.charge-generated-link-commercial:hover {
  color: #15803d;
  text-decoration: underline;
}

.charge-generated-btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #1f2937;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
}

.charge-generated-btn-secondary:hover {
  border-color: #d1d5db;
  background: #f9fafb;
}
</style>



// WEBPACK FOOTER //
// src/components/Subscription/ChargeGeneratedModal.vue